import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import TemplateIcon from "../../assets/icons/library_puzzle.svg2";
import HelpButton from "../HelpContent/HelpButton";
import MyModal from "../Common/MyModal";
import BroadcastTemplateLibrary from "../Library/BroadcastTemplateLibrary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import LightBroadcast from "../Broadcast/LightBroadcast";

function CreateABroadcastDropdown() {
  const [show, setShow] = useState(false);
  return (
    <Dropdown onToggle={setShow} show={show}>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShow((p) => !p);
        }}
        className="btn btn-sm bg-purple-gradient rounded-3 text-purple text-small fw-bold w-100"
      >
        Start with a..
        <FontAwesomeIcon icon={faChevronDown} className="float-end mt-1" />
      </button>
      <Dropdown.Menu className="bg-purple-gradient">
        <Dropdown.Item>
          <MyModal
            size="xxl"
            label={
              <div className="d-flex align-items-center justify-content-between gap-3">
                <div>
                  <TemplateIcon width={30} />
                </div>
                <div className="flex-grow-1">
                  <h5 className="fw-bold text-purple text-start">Template </h5>
                  <span className="text-secondary">Use or edit Template</span>
                </div>
                <HelpButton helpKey="broadcast-templates" />
              </div>
            }
            buttonClassName=" rounded-4 start text-black border-0 "
            modalClassName="bg-purple-gradient"
          >
            <BroadcastTemplateLibrary isModal />
          </MyModal>
        </Dropdown.Item>
        <Dropdown.Item>
          <MyModal
            size="lg"
            label={
              <div className="d-flex align-items-center justify-content-between gap-3">
                <div>
                  <TemplateIcon width={30} />
                </div>
                <div className="flex-grow-1">
                  <h5 className="fw-bold text-purple text-start">
                    Quick broadcast{" "}
                  </h5>
                  <span className="text-secondary">
                    Create a quick broadcast
                  </span>
                </div>
                <HelpButton helpKey="quick-broadcast" />
              </div>
            }
            heading="Quick Broadcast"
            buttonClassName=" rounded-4 start text-black border-0 "
            modalClassName="bg-purple-gradient"
          >
            <LightBroadcast />
          </MyModal>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default CreateABroadcastDropdown;
